<template lang="pug">
  div(:class="$style.modalFooter")
    div(
      @click="$emit('toggle-summary')"
      :class="$style.truckContainer")
      AnyVanAnimatedVanIcon(
        :counter="furniture_getItemsCount ?? 0"
        :size="38")
      Icon(
        :name="summaryOpened ? 'i:angle-down' : 'i:angle-up'"
        :size="30"
        :class="$style.chevronIcon")
    Btn(
      @click="$emit('submit-form')"
      :disabled="furniture_getItemsCount === 0 || formSubmitted"
      kind="red"
      block
      :loading="formSubmitted"
      :icon-right="'i:chevron-right'") {{ $t('items.submit') }}

</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import { GET_ITEMS_COUNT } from "~/store/listing"

export default defineComponent({
  name: "CartFooter",
  props: {
    summaryOpened: {
      type: Boolean,
      default: false
    },
    formSubmitted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("listing", {
      furniture_getItemsCount: GET_ITEMS_COUNT
    })
  }
})
</script>

<style lang="scss" module>
.modalFooter {
  @apply w-full bg-white p-ds-sm flex justify-between self-end h-auto border-t border-black20;

  .truckContainer {
    @apply flex mr-ds-sm items-center cursor-pointer;
  }

  .chevronIcon {
    @apply ml-ds-xxxs mt-[-10px] self-start;
  }

  button {
    svg {
      @apply mr-ds-sm;
    }
  }
}
</style>
